export const time = {
  second: 1000,
  minute: 1000 * 60,
  hour: 1000 * 60 * 60,
};
